import React from 'react';
import { useNavigate } from 'react-router-dom';

import ActionsDropdown from 'components/partials/actions-dropdown';
import type { ActionsDropdownOption } from 'components/partials/actions-dropdown/actions-dropdown';

import type { AidModelDto } from 'api/generated/schemas/aidModelDto';

import Icons from 'assets/icons';

export interface AidModelRowActions {
  onClone: (model: AidModelDto) => void;
  onArchive: (model: AidModelDto) => void;
  onRestore: (model: AidModelDto) => void;
}

const ModelActionCell = ({
  model,
  detailsPath,
  actions,
}: {
  model: AidModelDto;
  detailsPath: string;
  actions: AidModelRowActions;
}) => {
  const navigate = useNavigate();
  const canEdit = !!model.canEdit && !model.archived;
  const canArchive = !!model.canArchive;

  const options: ActionsDropdownOption[] = [
    {
      label: canEdit ? 'Edit' : 'View',
      startIcon: canEdit ? (
        <Icons.EditPencil className="size-4" aria-hidden="true" />
      ) : (
        <Icons.Eye className="size-4" aria-hidden="true" />
      ),
      onClick: () => {
        navigate(detailsPath);
      },
    },
    {
      label: 'Clone',
      startIcon: <Icons.Copy className="size-4" aria-hidden="true" />,
      onClick: () => actions.onClone(model),
    },
  ];

  if (canArchive) {
    options.push(
      model.archived
        ? {
            label: 'Restore',
            startIcon: <Icons.Release className="size-4" aria-hidden="true" />,
            onClick: () => actions.onRestore(model),
          }
        : {
            label: 'Archive',
            startIcon: <Icons.Archived className="size-4" aria-hidden="true" />,
            onClick: () => actions.onArchive(model),
          }
    );
  }

  return (
    <ActionsDropdown
      options={options}
      ariaLabel={`Actions for ${model.name ?? 'model'}`}
      variant="reserve-outlined"
      customClass="size-8 p-0 border-solid"
      menuCustomClass="w-[190px] [&_button]:font-normal"
    />
  );
};

export default ModelActionCell;
